import { render, staticRenderFns } from "./Choose.vue?vue&type=template&id=3968f70e&scoped=true&"
import script from "./Choose.vue?vue&type=script&lang=js&"
export * from "./Choose.vue?vue&type=script&lang=js&"
import style0 from "./Choose.vue?vue&type=style&index=0&id=3968f70e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3968f70e",
  null
  
)

export default component.exports